import { TextCell } from "@similarweb/pro-logic-components";

import {
    CellDefaultTooltip,
    ListCell,
    renderDefaultTextCell,
    createPrimitiveListCellValue,
} from "app/pages/sales-intelligence/common-components/table-cells";
import { createRegularColumnFactory } from "app/pages/sales-intelligence/modules/apps-search/configuration/columns/utils";
import type { AppsColumnListConfig } from "app/pages/sales-intelligence/modules/apps-search/types/table";
import { createSharedColumnList } from "app/pages/sales-intelligence/pages/find-apps/configuration/columns/sharedColumnList";
import { AppsSourceType } from "app/pages/sales-intelligence/store/find-apps/types/appsSourceType";
import type { IFindAppsIosRowDto } from "app/pages/sales-intelligence/store/find-apps/types/dto";

export const iosTableColumnConfig: AppsColumnListConfig<IFindAppsIosRowDto> = new Map([
    ...(createSharedColumnList({
        i18nKeyModifier: AppsSourceType.AppleStore,
    }) as unknown as AppsColumnListConfig<IFindAppsIosRowDto>),

    [
        "track_id",
        createRegularColumnFactory({
            dataIndex: "track_id",
            render: (value: IFindAppsIosRowDto["track_id"]) => renderDefaultTextCell(value),
        }),
    ],
    [
        "categories",
        createRegularColumnFactory({
            dataIndex: "categories",
            render: (value: IFindAppsIosRowDto["categories"]) => (
                <ListCell
                    value={value}
                    dataAutomation="app-categories"
                >
                    {createPrimitiveListCellValue({ value })}
                </ListCell>
            ),
        }),
    ],
    [
        "bundle_id",
        createRegularColumnFactory({
            dataIndex: "bundle_id",
            ellipsis: true,
            render: (value: IFindAppsIosRowDto["bundle_id"]) => (
                <CellDefaultTooltip content={value}>
                    <TextCell>{value}</TextCell>
                </CellDefaultTooltip>
            ),
        }),
    ],
    [
        "primary_category",
        createRegularColumnFactory({
            dataIndex: "primary_category",
            render: (value: IFindAppsIosRowDto["primary_category"]) => renderDefaultTextCell(value),
        }),
    ],
]);
